import { BCDrawer, BCModal } from '@bimser/components';
import React from 'react';
import Style from '../assets/style.scss';
import IPanelComponentProps from '../entities/IPanelComponentProps';
import usePanelComponent from './usePanelComponent';

const PanelComponent = (props: IPanelComponentProps) => {
	const [containerReady, setContainerReady] = React.useState(false);
	const { renderContent, title, onCancelClick, renderHeader, componentWidth, canFullScreen } =
		usePanelComponent(props);

	return React.useMemo(() => {
		const afterOpenChange = (open: boolean) => {
			if (open) {
				setContainerReady(true);
			}
		};

		if (props.type == 'drawer') {
			return (
				<BCDrawer
					className={Style.ComponentContainer + ` ${props.className || ''}`}
					open
					width={props.width}
					maskClosable={props.maskClosable}
					onClose={onCancelClick}
					title={renderHeader(title)}
					afterOpenChange={afterOpenChange}
				>
					<div className={Style.ComponentContent}>
						{containerReady ? renderContent() : null}
					</div>
				</BCDrawer>
			);
		} else {
			return (
				<BCModal
					id={props.modalId}
					width={componentWidth ? componentWidth : props.width}
					visible
					handleCancel={onCancelClick}
					maskClosable={false}
					closable={false}
					title={title}
					className={Style.ComponentContainer + ` ${props.className || ''}`}
					keyboard={false}
					renderHeader={renderHeader}
					footer={null}
					disableScroll
					canFullScreen={canFullScreen}
					afterOpenChange={afterOpenChange}
				>
					<div className={[Style.ComponentContent, Style.isModal].join(' ')}>
						{containerReady ? renderContent() : null}
					</div>
				</BCModal>
			);
		}
	}, [renderContent, title, onCancelClick, renderHeader, canFullScreen, containerReady]);
};

export default PanelComponent;
